import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  ClassificationsQuery as ClassificationsQueryType,
  ClassificationsQueryVariables,
} from "./__generated__/ClassificationsQuery";

const ClassificationsQuery = loader("./ClassificationsQuery.gql");

type ClassificationsQueryProviderType = (props: {
  children: (data: ClassificationsQueryType) => ReactNode;
  variables?: ClassificationsQueryVariables;
}) => ReactElement;

export const ClassificationsQueryProvider: ClassificationsQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<ClassificationsQueryType>(ClassificationsQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
